import React from 'react';
import { motion } from 'framer-motion';
import heroImage from '../assets/images/hero-kids.jpg';

const Hero: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        delayChildren: 0.3,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: [0.43, 0.13, 0.23, 0.96]
      }
    }
  };

  return (
    <div className="relative h-screen overflow-hidden">
      {/* Image d'arrière-plan avec effet de parallaxe */}
      <motion.div
        className="absolute inset-0 z-0"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
        <div 
          className="absolute inset-0 bg-cover bg-center" 
          style={{ 
            backgroundImage: `url(${heroImage})`,
            backgroundPosition: 'center 30%'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#87CEFA33] via-[#87CEFA33] to-[#1C1C1C]" />
      </motion.div>

      <div className="container mx-auto px-4 h-full relative z-10 flex flex-col justify-center">
        <motion.div
          className="max-w-3xl"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.h1 
            className="text-4xl md:text-6xl font-bold text-white mb-4"
            variants={itemVariants}
          >
            Découvrez des activités <span className="text-[#FFD700]">enrichissantes</span> pour vos enfants
          </motion.h1>
          
          <motion.p 
            className="text-xl md:text-2xl text-white opacity-90 mb-8"
            variants={itemVariants}
          >
            La plateforme qui relie les familles aux meilleures activités culturelles et de loisirs pour enfants dans votre ville.
          </motion.p>
          
          <motion.div 
            className="flex flex-col sm:flex-row gap-4"
            variants={itemVariants}
          >
            <motion.a
              href="#activities"
              className="bg-[#FFD700] hover:bg-[#F8C400] text-[#1C1C1C] font-bold py-3 px-6 rounded-lg shadow-lg transition-colors text-center"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Découvrir les activités
            </motion.a>
            <motion.a
              href="#partners"
              className="bg-transparent border-2 border-white hover:border-[#FFD700] text-white hover:text-[#FFD700] font-bold py-3 px-6 rounded-lg transition-colors text-center"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Devenir partenaire
            </motion.a>
          </motion.div>
        </motion.div>
      </div>

      {/* Flèche de défilement animée */}
      <motion.div 
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          duration: 0.5, 
          delay: 1.5,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      >
        <a href="#activities" className="text-white">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </a>
      </motion.div>
    </div>
  );
};

export default Hero;
